export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  EDITOR: '/editor',
  CREATE_POST: '/post/create',
  LOGIN: '/login',
  SIGNUP: '/signup',
  PROFILE: '/profile',
  CONTENT_BUCKETS: '/content-buckets',
};